<script setup>
import { computed } from 'vue'
import { useConfigStore } from "@/stores/ConfigStore"

const emit = defineEmits(['upgrade'])

const configStore = useConfigStore()

const subscription = computed(() => configStore.getConfigField('subscription'))
const hasActiveSubscription = computed(() => configStore.getConfigField('hasActiveSubscription'))
const topPlan = computed(() => configStore.topPlan)

</script>

<template>
  <button
    @click="$emit('upgrade')"
    class="hidden md:flex items-center gap-x-1.5 pl-1.5 pr-2.5 py-2 transition duration-300 bg-blue-50 text-tint-1 rounded"
    :class="{ '!p-0': !subscription?.plan_id }"
    aria-label="Handle Upgrade"
  >
    <template
      v-if="
        subscription?.plan_id &&
        (!subscription ||
          (hasActiveSubscription &&
            subscription?.plan_id !== topPlan?.id))
      "
    >
      <Icon icon="heroicons:fire-16-solid" />
      <span class="text-xs font-semibold">Upgrade</span>
    </template>
    <template
      v-else-if="
        subscription?.plan_id &&
        subscription &&
        !hasActiveSubscription
      "
    >
      <Icon icon="heroicons:bolt" />
      <span class="text-xs font-semibold">Reactivate Account</span>
    </template>
    <template v-else>
      <div class="w-[88px] invisible h-0"></div>
    </template>
  </button>
</template>
